// extracted by mini-css-extract-plugin
var _1 = "mIDgt";
var _2 = "NeBvW";
var _3 = "z8pU3";
export { _1 as "base", _2 as "form", _3 as "modalActions" }
